module.exports = __webpack_public_path__ + "img/partner17.7a3799ea.png";